import React from 'react';
import { Card, Tabs } from 'antd';
import GatewayTab from './GatewayTab';
import ProviderServiceTab from './ProviderServiceTab';
import ServiceMappingListPage from '../service-mapping/List';
import LabelProcessingRuleTab from './LabelProcessingRuleTab';

const LogisticsSystemPage: React.FC = () => {
  return (
    <div className="p-6">
      <Card title="物流系统">
        <Tabs
          defaultActiveKey="gateway"
          items={[
            { key: 'gateway', label: '物流网关管理', children: <GatewayTab /> },
            { key: 'provider-service', label: '承运商与物流产品', children: <ProviderServiceTab /> },
            { key: 'service-mapping', label: '网关物流产品管理', children: <ServiceMappingListPage /> },
            { key: 'label-processing-rule', label: '标签处理规则', children: <LabelProcessingRuleTab /> },
          ]}
        />
      </Card>
    </div>
  );
};

export default LogisticsSystemPage;
